export default __webpack_public_path__ + "e8860395cfec4babecaebc9213f952f6.svg";